import { useSelector } from 'react-redux'

const useValidatePartiesAtMerchandise = () => {
  const {
    consigneeList,
    consignorsList,
    additionalSupplyChainActorsList
  } = useSelector(state => state.actorReducer)

  const maxAllowedConsigneeList = consigneeList?.length > 0 ? 0 : 1
  const maxAllowedConsignorsList = consignorsList?.length > 0 ? 0 : 1

  return { maxAllowedConsigneeList, maxAllowedConsignorsList }
}

export default useValidatePartiesAtMerchandise